import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { queryClient } from '@/lib/queryClient';
import { useThemeEffect } from '@/stores/ui.store';
import { ToastProvider } from '@/components/ui/Toast';
import { router } from '@/routes';

export function App() {
  useThemeEffect();

  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  );
}
